const fontAwesomeFileTypeIcons = {
  // Media
  image: 'file-image',
  'image/png': 'file-image',
  'image/jpg': 'file-image',
  'image/jpeg': 'file-image',
  audio: 'file-audio',
  video: 'file-video',
  // Documents
  'application/pdf': 'file-pdf',
  'application/msword': 'file-word',
  'application/vnd.ms-word': 'file-word',
  'application/vnd.oasis.opendocument.text': 'file-word',
  'application/vnd.openxmlformatsfficedocument.wordprocessingml': 'file-word',
  'application/vnd.ms-excel': 'file-excel',
  'application/vnd.openxmlformatsfficedocument.spreadsheetml': 'file-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'file-excel',
  'application/vnd.oasis.opendocument.spreadsheet': 'file-excel',
  'application/vnd.ms-powerpoint': 'file-powerpoint',
  'application/vnd.openxmlformatsfficedocument.presentationml': 'file-powerpoint',
  'application/vnd.oasis.opendocument.presentation': 'file-powerpoint',
  'text/plain': 'file-alt',
  'text/html': 'file-code',
  'application/json': 'file-code',
  // Archives
  'application/gzip': 'file-archive',
  'application/zip': 'file-archive',
  // Directories
  'application/x-directory': 'folder',
};

const getFontAwesomeFileIcon = type => fontAwesomeFileTypeIcons[type] || 'file';

export default getFontAwesomeFileIcon;
